import { Component, Mixins } from "vue-property-decorator";
import CompanyMixin from "@/mixins/http/Company";
import store from "@/store";

@Component
class CompanyService extends Mixins(CompanyMixin) {
  created() {
    this.$store = store;
  }
}

export default new CompanyService();
